// extracted by mini-css-extract-plugin
export default {"root":"custom-switch_root__yUWwV","shadow":"custom-switch_shadow__LQXiv","option":"custom-switch_option__jrSYs"};